if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super()

        this.form = this.querySelector('form')
        this.form.querySelector('[name=id]').disabled = false
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
        this.cartPopup = document.querySelector('cart-popup')
        this.bundleProductId = this.dataset.bundleProduct
        this.bundleProductSellingPlan = this.dataset.bundleProductSellingPlan
        
        // This boolean value decides if on submit the bundled product gets added to the cart.
        if (this.dataset.enableBundleAddToCart) {
          this.enableBundleAddToCart = JSON.parse(this.dataset.enableBundleAddToCart)
        } else {
          this.enableBundleAddToCart = false
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault()
        const submitButton = this.querySelector('[type="submit"]')
        let showCart = true
        let shouldRedirect = false
        if (submitButton.classList.contains('loading')) return

        if (submitButton.classList.contains('no-cart')) {
          showCart = false
        }

        if (this.form.dataset.redirect === 'true') {
          shouldRedirect = true
          showCart = false
        }

        const addProduct = () => {
          this.handleErrorMessage()
          this.cartPopup.setActiveElement(document.activeElement)

          submitButton.setAttribute('aria-disabled', true)
          submitButton.classList.add('loading')
          this.querySelector('.loading-overlay__spinner').classList.remove('hidden')

          const config = fetchConfig('javascript')
          config.headers['X-Requested-With'] = 'XMLHttpRequest'
          delete config.headers['Content-Type']

          const formData = new FormData(this.form)
          formData.append(
            'sections',
            this.cartPopup.getSectionsToRender().map(section => section.section)
          )
          formData.append('sections_url', window.location.pathname)
          config.body = formData

          fetch(`${routes.cart_add_url}`, config)
            .then(response => response.json())
            .then(response => {
              if (response.status) {
                this.handleErrorMessage(response.description)
                return
              }
              document.getElementById('cart-live-region-text').textContent =
                'Product was added successfully to your shopping cart'
              setTimeout(() => {
                document.getElementById('cart-live-region-text').textContent = ''
              }, 3000)

              if (shouldRedirect && this.form.dataset.redirectUrl) {
                window.location.href = this.form.dataset.redirectUrl
              }

              this.cartPopup.renderContents(response, showCart)
            })
            .catch(e => {
              console.error(e)
            })
            .finally(() => {
              submitButton.classList.remove('loading')
              submitButton.removeAttribute('aria-disabled')
              this.querySelector('.loading-overlay__spinner').classList.add('hidden')
              submitButton.classList.add('clicked')
              setTimeout(() => {
                submitButton.classList.remove('clicked')
              }, 3000)
              // const cartChangeEvent = new CustomEvent('tk:cart-updated');
              // document.dispatchEvent(cartChangeEvent);
            })
        }
        if (this.bundleProductId && this.enableBundleAddToCart) {
          this.addBundledProduct(addProduct)
        } else {
          addProduct()
        }
      }

      addBundledProduct(addProduct) {
        let p = {
          id: this.bundleProductId,
          quantity: 1,
        }
        if (this.bundleProductSellingPlan) {
          p.selling_plan = this.bundleProductSellingPlan
        }
        // lets add this product to cart then call the normal form after
        let bundleFormData = {
          items: [p],
        }
        return fetch(`${routes.cart_add_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(bundleFormData),
        })
          .then(() => {
            addProduct()
          })
          .catch(error => {
            console.error('Error:', error)
          })
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || document.querySelector('.product-form__error-message-wrapper')
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message')

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage
        }
      }
    }
  )
}
